export enum WebsocketMessagesEnum {
  DATA = 'DATA',
  INIT = 'INIT',
  PARAMS = 'PARAMS',
}
